import React, { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';

export type ShareLabelProps = {
  labelText: string;
};

export const ShareLabel: FunctionComponent<ShareLabelProps> = ({
  labelText,
}) => {
  const { t } = useTranslation('common', { useSuspense: false });

  return (
    <>
      <span className="jg-sr-only">{t('common.shareBy')}</span>
      {labelText}
    </>
  );
};
